import { FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { CreateProjectFormData, CreateProjectValidationErrors } from '../hooks/useCreateProjectValidation';
import { Input, DateInput, Textarea } from '../../../components/shared';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

interface CreateProjectFormProps {
  formData: CreateProjectFormData;
  onChange: (field: keyof CreateProjectFormData, value: string | boolean) => void;
  onSubmit: (e: FormEvent) => void;
  errors: CreateProjectValidationErrors;
  loading: boolean;
}

export function CreateProjectForm({ formData, onChange, onSubmit, errors, loading }: CreateProjectFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-8" data-testid="create-project-form">
      <Input
        label="Nome do Projeto *"
        type="text"
        value={formData.name}
        onChange={(e) => onChange('name', e.target.value)}
        error={errors.name}
        loading={loading}
        required
        variant="primary"
      />

      <Textarea
        label="Endereço"
        value={formData.address}
        onChange={(e) => onChange('address', e.target.value)}
        error={errors.address}
        loading={loading}
        rows={3}
        variant="primary"
      />

      <div className="grid grid-cols-2 gap-6">
        <DateInput
          label="Data de Início"
          value={formData.startDate}
          onChange={(e) => onChange('startDate', e.target.value)}
          loading={loading}
          variant="primary"
        />

        <DateInput
          label="Data de Término"
          value={formData.endDate}
          onChange={(e) => onChange('endDate', e.target.value)}
          error={errors.endDate}
          loading={loading}
          variant="primary"
        />
      </div>

      <Input
        label="Método de Pagamento *"
        type="text"
        value={formData.paymentMethod}
        onChange={(e) => onChange('paymentMethod', e.target.value)}
        loading={loading}
        required
        placeholder="ex.: Mensal, Marcos, Fixo"
        error={errors.paymentMethod}
        variant="primary"
      />

      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <Switch
            id="hasConstructionTracking"
            checked={formData.hasConstructionTracking}
            onCheckedChange={(checked) => onChange('hasConstructionTracking', checked)}
            disabled={loading}
          />
          <Label htmlFor="hasConstructionTracking" className="text-sm text-primary-900 dark:text-white cursor-pointer">
            Habilitar Acompanhamento de Construção (Diário de Obra)
          </Label>
        </div>

        <div className="flex items-center gap-3">
          <Switch
            id="hasAdhocTracking"
            checked={formData.hasAdhocTracking}
            onCheckedChange={(checked) => onChange('hasAdhocTracking', checked)}
            disabled={loading}
          />
          <Label htmlFor="hasAdhocTracking" className="text-sm text-primary-900 dark:text-white cursor-pointer">
            Habilitar Acompanhamento Ad-hoc
          </Label>
        </div>
      </div>

      <Textarea
        label="Notas Internas (Apenas Admin)"
        value={formData.internalNotes}
        onChange={(e) => onChange('internalNotes', e.target.value)}
        loading={loading}
        rows={4}
        placeholder="Notas visíveis apenas para administradores"
        variant="primary"
      />

      <div className="flex gap-4">
        <Button type="submit" disabled={loading}>
          {loading ? 'CRIANDO...' : 'CRIAR PROJETO'}
        </Button>
        <Button asChild variant="outline">
          <Link to="/dashboard">CANCELAR</Link>
        </Button>
      </div>
    </form>
  );
}